import { render } from "./HomeAbout.vue?vue&type=template&id=01017f50&scoped=true"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"

import "./HomeAbout.vue?vue&type=style&index=0&id=01017f50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01017f50"]])

export default __exports__